import React, { useEffect } from 'react';
import { persistor } from './store';

const Logout = () => {
  useEffect(() => {
    persistor.purge().then(() => {
      localStorage.clear();
      window.location.href = '/';
    });
  }, []);
  return null;
};

export default Logout;
